/* eslint-disable css-modules/no-unused-class  */
import { useRef } from 'react';
import AliceCarousel from 'react-alice-carousel';
import { Icon } from 'learning-panel-components';
import { GalleryProps } from './galleryTypes';
import 'react-alice-carousel/lib/scss/alice-carousel.scss';
import styles from './gallery.module.scss';

const Gallery = (props: GalleryProps): JSX.Element => {
    const { children, numberOfElements, topAction = false } = props;
    const carousel = useRef<AliceCarousel>(null);
    return (
        <div className={topAction ? styles['gallery-top-actions'] : styles.gallery}>
            <AliceCarousel mouseTracking items={children} infinite disableButtonsControls ref={carousel} />
            <div key="btns">
                <Icon
                    onClick={(e: any) => carousel?.current?.slideNext(e)}
                    name="chevronRight"
                    className={styles['prev-btn']}
                />
                <Icon
                    onClick={(e: any) => carousel?.current?.slidePrev(e)}
                    name="chevronLeft"
                    style={{ '--prevRight': `${numberOfElements * 1.1 + 3.5}rem` } as any}
                    className={styles['next-btn']}
                />
            </div>
        </div>
    );
};

export default Gallery;
